import { format as dateFnsFormat } from 'date-fns';
import { utcToZonedTime, zonedTimeToUtc } from 'date-fns-tz';

/**
 * Get user's local timezone
 * @returns {string} IANA timezone string (e.g., 'Asia/Kathmandu', 'America/New_York')
 */
export const getUserTimezone = () => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
};

/**
 * Convert UTC time to user's local timezone and format it
 * @param {string|Date} utcTime - UTC time from database
 * @param {string} formatString - date-fns format string (e.g., 'HH:mm', 'MMM dd, yyyy')
 * @returns {string} Formatted local time
 */
export const formatLocalTime = (utcTime, formatString = 'HH:mm') => {
  if (!utcTime) return '—';
  
  try {
    const date = new Date(utcTime);
    const timezone = getUserTimezone();
    const localDate = utcToZonedTime(date, timezone);
    return dateFnsFormat(localDate, formatString);
  } catch (error) {
    console.error('Error formatting local time:', error);
    return '—';
  }
};

/**
 * Get current time in user's local timezone
 * @returns {Date} Current time in local timezone
 */
export const getCurrentLocalTime = () => {
  return new Date();
};

/**
 * Convert local time to UTC for API submission
 * @param {Date} localTime - Local time from user input
 * @returns {Date} UTC time
 */
export const localTimeToUTC = (localTime) => {
  const timezone = getUserTimezone();
  return zonedTimeToUtc(localTime, timezone);
};

/**
 * Get today's date in user's local timezone (YYYY-MM-DD format)
 * @returns {string} Today's date in local timezone
 */
export const getTodayLocalDate = () => {
  const timezone = getUserTimezone();
  const now = new Date();
  const localDate = utcToZonedTime(now, timezone);
  return dateFnsFormat(localDate, 'yyyy-MM-dd');
};

// Backward compatibility aliases for Nepal-specific functions
export const formatNepalTime = formatLocalTime;
export const getCurrentNepalTime = getCurrentLocalTime;
export const nepalTimeToUTC = localTimeToUTC;
